import { ReactNode } from 'react';
import cn from 'classnames';
import Grid from '@creditflowresearch/uilib/Grid';
import GridItem from '@creditflowresearch/uilib/GridItem';

import styles from './panelLayout.module.scss';

interface IPanelLayoutDesktopProps {
  children?: ReactNode,
  className?: string,
  dataTest?: string,
  headerPanel: ReactNode,
  leftContent?: ReactNode,
  rightContent?: ReactNode,
}

const PanelLayoutDesktop = ({
  children,
  className,
  dataTest = 'panelLayoutDesktop',
  headerPanel,
  leftContent,
  rightContent,
}: IPanelLayoutDesktopProps) => {
  const contentClasses = cn(
    styles.desktopPanelContent,
    className,
  );

  return (
    <Grid
      className={ contentClasses }
      data-test={ dataTest }
      templateRows="auto 1fr"
      templateColumns="1fr"
    >
      <GridItem className={ styles.subHeaderRow }>
        { headerPanel }
      </GridItem>

      <GridItem style={ { overflow: 'hidden' } }>
        <Grid
          className={ styles.rowsContainer }
          templateColumns="310px 1fr"
        >
          <GridItem className={ styles.leftRow } data-test="panelLayoutLeftRow">
            { leftContent }
          </GridItem>

          <GridItem className={ styles.rightRow } data-test="panelLayoutRightRow">
            { rightContent }
          </GridItem>
        </Grid>
      </GridItem>

      { children && (
        <GridItem>
          { children }
        </GridItem>
      ) }
    </Grid>
  );
};

export default PanelLayoutDesktop;
